import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import CertificateTemplateSelection from "../../components/Certificates/CertificateTemplateSelection";
import CertificateProductSelection from "../../components/Certificates/CertificateProductSelection";

function CertificatesClone({ history }) {
  const [certificateToBeCloned, setCertificateToBeCloned] = useState(null);

  function handleCertificateToBeCloned(data) {
    setCertificateToBeCloned(data);
    console.log(data);
  }

  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <p className="card-text">
                      <FormattedMessage
                        id="certificates.clone_certificate.description"
                        defaultMessage="Select from the options below to select the certificate you would like to clone."
                      />
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3">
                    {certificateToBeCloned == null ? (
                      <CertificateTemplateSelection clone={true} onCertificateClone={handleCertificateToBeCloned}></CertificateTemplateSelection>
                    ) : (
                      <>
                        <CloneSummary data={certificateToBeCloned}></CloneSummary>
                        <Card>
                          <CardBody>
                            <CertificateProductSelection cloneData={certificateToBeCloned} history={history}></CertificateProductSelection>
                          </CardBody>
                        </Card>
                      </>
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

function CloneSummary({ data }) {
  return (
    <Card className="mb-3">
      <CardBody>
        <h2>
          <FormattedMessage id="certificates.clone_summary" defaultMessage="Clone summary" />
        </h2>
        <span className="mr-3">
          <b>
            <FormattedMessage id="certificates.reference" defaultMessage="Reference" />
          </b>{" "}
          {data.documentReference}
        </span>
        <span className="mr-3">
          <b>
            <FormattedMessage id="app.series" defaultMessage="Series" />
          </b>{" "}
          {data.shortNameComercial.join(", ")}
        </span>
        <span className="mr-1">
          <b>
            <FormattedMessage id="app.options" defaultMessage="Options" />
          </b>
        </span>
        {data.options.includeRegulations && (
          <span className="mr-3">
            <FormattedMessage id="certificates.define_regulations" defaultMessage="Regulations" />
          </span>
        )}
        {data.options.includeValidity && (
          <span className="mr-3">
            <FormattedMessage id="certificates.validity" defaultMessage="Validity" />
          </span>
        )}
        {data.options.includePDFS && (
          <span className="mr-3">
            <FormattedMessage id="certificates.pdfs" defaultMessage="PDFs" />
          </span>
        )}
      </CardBody>
    </Card>
  );
}

export default CertificatesClone;
